import { render, staticRenderFns } from "./AntGinecologicosTable.vue?vue&type=template&id=6f3d7405"
import script from "./AntGinecologicosTable.vue?vue&type=script&lang=js"
export * from "./AntGinecologicosTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports